@import 'styles/mixins';
@import 'styles/variables';

.positionContainer {
  position: absolute;
  z-index: z-index(linkPopup);
  top: 0;
  left: 0;
}

.positionContainerAnimated {
  transition: opacity 0.1s cubic-bezier(0.9, 0, 0.6, 1);
}
